export { default } from "./TransferReportsSuccessStepView";
